import { Session } from 'inspector';
import moment from 'moment';
import { getRenewalStartingTime, handleAutoLogout } from '../../pages/common/functions';

export const getCurrentUser = () => {
  const loggedInString = localStorage.getItem('AUTHDATA');
  if (loggedInString) {
    const loggedInData = JSON.parse(loggedInString);
    return loggedInData;
  }
  else {
    return null;
  }
}

export const getLoggedUsername = () => {
  var loginData = getCurrentUser()
  if (loginData) {
		var query = loginData.info.userName;
    return query;
  }
  else {
    return "";
  }
}

export const getIsAdminLogged = () => {
	var loginData = getCurrentUser()
	if (loginData && loginData.info) {
		var isAdmin = loginData.info.isAdmin;
		return isAdmin;
	}
	else {
		return false;
	}
}

export const getLoggedUser = () => {
	var loginData = getCurrentUser()
	if (loginData) {
		var query = loginData.info.firstName + " " + loginData.info.lastName;
		return query;
	}
	else {
		return "";
	}
}

export const getLoggedUserId = () => {
  var userData = getCurrentUser()
  if (userData) {
    return userData.info.userId;
  }
  else
    return 0;
}

export const getUserAccessToken = () => {
	var accessToken = "";
	var accessTokenValue = window.localStorage.getItem('accessToken');
	if (accessTokenValue)
		accessToken = accessTokenValue;

	return accessToken;
}

export const setUserAccessToken = (token) => {
	var accessToken = "";
	if (token)
		accessToken = token

	window.localStorage.setItem('accessToken', accessToken);
}

//getting login data
export const getAuthData = () => {
	var sessionExpiry = window.localStorage.getItem('SESSIONEXPIRY');
	var loginData = getCurrentUser();

	if (loginData) {
		if (loginData.refreshToken && loginData.refreshToken.length > 0) {
			var expiredAtUtc = moment(loginData.expiredAtUtc).format();
			if (expiredAtUtc && expiredAtUtc.length > 0 && !isNaN(Date.parse(expiredAtUtc))) {
				var expiredDate = moment(expiredAtUtc).get('date');
				var expiredMonth = moment(expiredAtUtc).get('month') +1
				var currDate = new Date().getUTCDate();
				var currMonth = new Date().getUTCMonth() +1;
				if (expiredDate >= currDate || expiredMonth >= currMonth) {
					return loginData
				}
				else {
					clearStorageValues();
					return null;
				}
			}
			else {
				clearStorageValues();
				return null;
			}
		}
		else {
			if (Date.now() > Number(sessionExpiry) + getRenewalStartingTime()) {
				handleAutoLogout()
				return null;
			} else {
				return loginData;
			}			
		};
	}
	else {
		return null;
	};
}

export const setAuthData = (loginData: any) => {
	if (loginData) {
		var accessTokenValue		= loginData.accessToken;
		var sessionTimeoutValue		= loginData.sessionTimeout;
		var infoValue				= loginData.info;
		var refreshTokenValue		= loginData.refreshToken; 	
		var expiredAtUtcValue		= loginData.expiredAtUtc;
		var loginByRefreshTokenValue = loginData.loginByRefreshToken;
		var isSuccessValue			 = loginData.isSuccess;

		const authData = {
			info: infoValue,
			refreshToken: refreshTokenValue,
			expiredAtUtc: expiredAtUtcValue,
			loginByRefreshToken: loginByRefreshTokenValue,
			sessionTimeout: sessionTimeoutValue,
			isSuccess: isSuccessValue,
		};
		window.localStorage.setItem('AUTHDATA', JSON.stringify(authData));	
		window.localStorage.setItem('accessToken', accessTokenValue);	
		sessionStorage.setItem('renewalInProgress', false.valueOf().toString());	
	}
	else {
		clearStorageValues();
	}
}

export const clearStorageValues = () => {
	window.localStorage.removeItem('accessToken');
	window.localStorage.removeItem('AUTHDATA');
	window.localStorage.removeItem('SESSIONEXPIRY');
	sessionStorage.removeItem("renewalInProgress");
	window.localStorage.removeItem("langCode");
	window.localStorage.removeItem("channelId");
	window.localStorage.removeItem("bibleId");
	window.localStorage.removeItem("fromPage");
	window.localStorage.removeItem("Filter");
	sessionStorage.removeItem("userId");
	sessionStorage.removeItem("resFilter");
}


